<template>
  <div class="map-home" v-if="activityInfo">
    <div v-if="isOpenLink" @click="back" class="back">返回</div>
    <div v-if="!isOpenLink" class="map-fake-container">
      <header v-if="activityInfo.bannerImage" class="banner"><img :src="activityInfo.bannerImage" alt="" /></header>
      <div id="map-container"></div>
      <Info-card
        v-if="nowSelectedInfo"
        :data="nowSelectedInfo"
        :userPosition="userPosition"
        mode="card"
        :activityInfo="activityInfo"
      ></Info-card>
      <Info-list
        :barTitle="''"
        :page="page"
        :isShowInfoList.sync="isShowInfoList"
        :userPosition="userPosition"
        :activityInfo="activityInfo"
        :getShopInfo="updateStoreList"
        :shopDataList="shopDataList"
      />
      <Info-list
        :barTitle="barTitle"
        :isShowInfoList.sync="isShowOverLappingShopDataList"
        :userPosition="userPosition"
        :activityInfo="activityInfo"
        :getShopInfo="updateStoreList"
        :shopDataList="overLappingShopDataList"
      />
      <Artifact-list
        v-if="nowSelectedInfo"
        :handleClickArtifactItem="handleClickArtifactItem"
        :activityInfo="activityInfo"
        :storeInfo="nowSelectedInfo"
      />
      <Search
        v-if="isShowSearch"
        :handleSelectStore="handleSelectStore"
        :handleSelectRoute="handleSelectRoute"
        :searchBtnText="searchBtnText"
      />
      <transition name="fade">
        <div class="mask" @click="isShowSearchBox = false" v-show="isShowSearchBox"></div>
      </transition>
      <Slider v-if="isShowCategories" :categories="activityInfo.mapStyle.categories" :handleSelectCategory="handleSelectCategory" />
      <SelectBar
        v-show="isShowSelectBar"
        ref="selectBarRef"
        :activityInfo="activityInfo"
        :handleSelectMore="handleSelectMore"
        :handleSelectCity="handleSelectCity"
        :handleSelectDistrict="handleSelectDistrict"
        :handleSelectLine="handleSelectLine"
      />
      <div class="icon-content">
        <RedRoute v-if="showRedRoute" />
        <ClockIcon v-if="isShowClockIn" />
        <DescIcon v-if="isShowDescIcon" />
        <ShopListIcon
          v-if="isShowShopList"
          :handelShopListIconClick="handelShopListIconClick" />
        <FocusLocalIcon
          v-if="isShowFocusLocal"
          :userPosition="userPosition"
          :map="map" />
      </div>
      <!--pc端放大缩小地图的调试工具-->
      <div style="display: none; position: fixed; width: 0.68rem; height: 1.4rem; bottom: 0.3rem; right: 0; font-size: 0.28rem">
        <p style="font-size: 0.68rem" @click="map.setZoom(mockZoom++)">+</p>
        <p style="font-size: 0.68rem" @click="map.setZoom(mockZoom--)">-</p>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './components/Search'
import Slider from './components/Slider'
import SelectBar from './components/SelectBar'
import FocusLocalIcon from './components/FocusLocalIcon'
import RedRoute from './components/RedRoute'
import ShopListIcon from './components/ShopListIcon'
import ClockIcon from './components/ClockIcon'
import DescIcon from './components/DescIcon'
import InfoCard from './components/InfoCard'
import InfoList from './components/InfoList'
import ArtifactList from './components/ArtifactList'
import { isInView } from './utils/calcDistance'
import { mapGetters, mapMutations, mapActions } from 'vuex' // mapActions
import { getShopInfo, getActivityInfo, summarize, getOverLappingShopInfo, getShopList } from '@/server/interfaces'
import setDocuemntTtitle from '@/utils/setDocumentTitle'
import { initShare } from '@/utils/share'
import throttle from '@/utils/throttle'
import { getDistance } from '@/utils/amap'
import { buryingPoint } from '@/utils/buryingPoint'

export default {
  components: {
    SelectBar,
    Slider,
    Search,
    FocusLocalIcon,
    ShopListIcon,
    ClockIcon,
    InfoCard,
    InfoList,
    ArtifactList,
    RedRoute,
    DescIcon
  },
  data () {
    return {
      countyCityList: ['乐昌市', '罗定市', '化州市', '南雄市', '台山市', '开平市', '鹤山市', '恩平市', '廉江市', '雷州市', '吴川市', '高州市', '信宜市', '四会市', '兴宁市', '陆丰市', '阳春市', '英德市', '连州市', '普宁市'],
      isShowSearchBox: false,
      isShowInfoList: false,
      userPosition: null,
      defaultPosition: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true
      },
      map: null,
      activityInfo: {},
      nowSelectedInfo: null,
      nowSelectedMarkerDom: null,
      shopDataList: [],
      distance: 20,
      coordinates: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true
      },
      zoom: 10, // 初始zoom等级设置为11 省选市为8
      page: 0,
      pageSize: 20,
      loading: false,
      markerList: [],
      circlrMarkerList: [],
      selectBarSetting: {},
      iframSrc: '',
      isOpenLink: false,
      gdCityList: [],
      markerMode: null, // cityMode, districtMode, noneMode, detailMode
      circlrMarkerIdsList: [],
      markerIdList: [],
      currentRouteId: '',
      mockZoom: 10, // 调试用的工具
      barTitle: '重叠',
      isShowOverLappingShopDataList: false,
      overLappingShopDataList: [],
      selectedDistrict: null,
      cityMapStoreList: {}, // 缓存城市信息点，优化性能
      districtMapStoreList: {}, // 缓存区域信息点，优化性能
      searching: false,
      isDistrictFiltered: false // 是否处于区筛选状态
    }
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId',
      storeActivityInfo: 'activityInfo/activityInfo',
      isShowArtifactList: 'home/isShowArtifactList',
      selectCategorieUid: 'home/selectCategorieUid',
      moreOptionsId: 'home/moreOptionsId',
      selectedCity: 'home/selectedCity',
      selectCategorieName: 'home/selectCategorieName',
      selectedLine: 'home/selectedLine',
      selectorSelectedDistrict: 'home/selectedDistrict'
    }),
    fnModule () {
      return this.activityInfo.mapStyle?.fnModule || {}
    },
    // 是否显示搜索
    isShowSearch () {
      return this.activityInfo.mapStyle?.fnModule?.search?.check
    },
    // 是否显示分类
    isShowCategories () {
      return this.activityInfo.mapStyle?.categories?.length > 0
    },
    // 是否显示城市下拉
    isShowSelectBar () {
      return this.activityInfo.mapStyle?.fnModule?.citySearch?.check || this.activityInfo.mapStyle?.fnModule?.moreSearch?.check
    },
    // 是否显示打卡
    isShowClockIn () {
      return this.activityInfo.mapStyle?.fnModule?.clockIn?.check
    },
    // 是否活动说明
    isShowDescIcon () {
      return this.activityInfo.mapStyle?.fnModule?.activityDesc?.check
    },
    searchBtnText () {
      return this.activityInfo.mapStyle?.fnModule?.search?.text
    },
    isShowShopList () {
      return this.selectedDistrict?.code || (this.selectedCity?.code && this.selectedCity?.code !== '440000')
    },
    isShowFocusLocal () {
      return this.markerMode === 'detailMode'
    },
    // 一期先按照次条件判断显影
    showRedRoute () {
      return this.activityInfo.name === '广东红色地图'
    }
  },
  created () {
    document.onclick = (e) => {
      if (e && e.target && e.target.parentNode?.classList.contains('icon-marker')) {
        buryingPoint({ action: 15, sourceTag: 2, activityId: this.activityId, optionId: e.target.parentNode.getAttribute('data-id') || '', itemType: 2 }) // 信息点点击埋点
        this.handleClickMarkerDom(e.target.parentNode)
      }
    }
  },
  async mounted () {
    buryingPoint({ action: 1, sourceTag: 2, activityId: this.activityId, itemType: 2 })
    await this.getActivityInfo()
    await this.initAMap()
    // 如果点击到map就清除掉聚焦效果
    this.map.on('click', () => {
      this.clearNowSelectedInfo()
    })
    // 跳转进入市一级的标识符
    this.getDistrictModeCenter = false
  },
  unmounted () {
    this.removeMapEventListener()
    this.map = null
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
      setShareInfo: 'activityInfo/setShareInfo',
      setIsShowArtifactList: 'home/setIsShowArtifactList',
      setSelectedCity: 'home/setSelectedCity'
    }),
    ...mapActions({
      initNfPluseShare: 'activityInfo/initNfPluseShare'
    }),
    removeMapEventListener () {
      this.map.off('moveend', this.moveMapend)
      this.map.off('zoomend', this.mapZoomend)
    },
    addMapEventListener () {
      this.map.on('moveend', this.moveMapend)
      this.map.on('zoomend', this.mapZoomend)
    },
    back () {
      this.isOpenLink && (this.isOpenLink = false)
    },
    firstEnterMap () {
      console.log('firstEnterMap', this.selectedCity)
      const shopId = this.$route.query?.shopId
      // 如果有shopId则显示到当前点位，不然优先聚焦到城市
      if (shopId) {
        this.focuseMarkerById(this.$route.query?.shopId)
      } else if (this.selectedCity?.code) {
        this.handleSelectCity({ ...this.selectedCity, first: true })
      } else {
        this.initMapMarkList()
      }
    },
    showSearchBox () {
      this.isShowSearchBox = !this.isShowSearchBox
    },
    matchCategoryImg (item) {
      if (item.redTemplate.fnModule?.exhibition?.check) {
        return item.redTemplate.topCategory.vrIcon
      } else {
        return item.redTemplate.topCategory.icon
      }
    },
    async selectMarkerDomById (id) {
      const markerDoms = document.querySelectorAll('.icon-marker')
      for (let i = 0; i < markerDoms.length; i++) {
        const item = markerDoms[i]
        if (item.dataset.id === id) {
          await this.handleClickMarkerDom(item)
        }
      }
    },
    async handleClickMarkerDom (target) {
      this.initAmapMarkDom()
      target.parentNode.parentNode.style.zIndex = 150
      target.className = 'icon shop-icon-box-active icon-marker'
      this.nowSelectedMarkerDom = target
      if (target.dataset?.hasadjacent === 'true') {
        await this.handleClickOverLapMarker(target.dataset.id)
      } else {
        this.nowSelectedInfo = this.shopDataList.find((item) => item.id === target.dataset.id)
      }
    },
    async handleClickOverLapMarker (id) {
      let res = await getOverLappingShopInfo({ params: { id } })
      res = res
        .map((item) => {
          item.distance = getDistance(
            { lng: this.userPosition.longitude, lat: this.userPosition.latitude },
            { lng: item.address.point.x, lat: item.address.point.y }
          )
          return item
        })
        .sort((prev, next) => prev.distance - next.distance)
      this.overLappingShopDataList = res
      this.barTitle = `当前位置重叠了${res.length}个${this.selectCategorieName}`
      this.isShowOverLappingShopDataList = true
      this.nowSelectedInfo = null
    },
    async focuseMarkerById (id) {
      return new Promise(async (r) => {
        this.setSelectedCity({ code: '440000', value: '全省' }) // 搜索时应该当将城市切换成全省
        let marker = this.markerList.filter((item) => {
          if (item.getExtData().id === id) {
            return item
          }
        })
        if (marker.length === 0) {
          this.shopDataList = await this.getStoreList({ storeId: id }, {})
          marker = this.addMapMarker(this.shopDataList)
          this.markerList.concat(marker)
        }

        this.map.setFitView(marker, false)
        setTimeout(() => {
          this.selectMarkerDomById(id).then(() => {
            r()
          })
        }, 500) // 没回调函数，只能用这个方式
      })
    },
    async handleSelectStore (id) {
      this.clearDistrictFilter()
      this.searching = true
      // this.removeMapEventListener()
      await this.focuseMarkerById(id)
      // this.addMapEventListener()
    },
    handleSelectRoute (id) {
      this.clearDistrictFilter()
      this.currentRouteId = id
      this.getMarkerListByFilterOptionAcytion()
      this.currentRouteId = ''
    },
    async handleSelectLine (item) {
      // 该地铁线路第一个站经纬度
      if (!item.station || !item.station[0] || !item.station[0].sl) {
        this.toast('无效的地铁站点信息')
        return
      }
      const sl = item.station[0].sl // "113.232521,23.066789"
      const [lngStr, latStr] = sl.split(',')
      const lng = parseFloat(lngStr)
      const lat = parseFloat(latStr)
      if (isNaN(lng) || isNaN(lat)) {
        this.toast('地铁站点经纬度格式错误')
        return
      }
      this.isDistrictFiltered = true
      // 跳转到第一个站
      this.map.setZoomAndCenter(15, [lng, lat])
      this.updateShopList()
    },
    // 带有区域选框条件时，通过该接口过滤
    async updateShopList (params = {}) {
      const res = await getShopList({
        cityCode: this.selectedCity.code,
        activityId: this.activityId,
        pageNum: 0,
        pageSize: 1000,
        belongSubway: this.selectedLine.line === '不限' ? undefined : this.selectedLine.line,
        districtCode: this.selectorSelectedDistrict.name === '不限' ? undefined : this.selectorSelectedDistrict.districtid,
        categoryIds: this.selectCategorieUid.concat(this.moreOptionsId),
        ...params
      })
      this.shopDataList = res.content.map((item) => {
        item.distance = getDistance(
          { lng: this.userPosition.longitude, lat: this.userPosition.latitude },
          { lng: item.address.point.x, lat: item.address.point.y }
        )
        return item
      })
      this.clearAllMarker()
      this.markerList = this.addMapMarker(this.shopDataList, 'detailMode')

      // 如有 跳转第一个信息点
      const firstPoint = this.shopDataList[0]
      const zoom = this.selectedLine.line !== '不限' ? 15 : 12
      firstPoint && this.map.setZoomAndCenter(zoom, [firstPoint.address.point.x, firstPoint.address.point.y])
    },
    async handleSelectDistrict (item) {
      const code = item.districtid
      // 1. 查找区对象
      let districtObj = null
      let cityObj = null
      for (const city of this.gdCityList) {
        if (city.districtList) {
          const found = city.districtList.find(d => d.adcode == code)
          if (found) {
            districtObj = found
            cityObj = city
            break
          }
        }
      }
      if (!districtObj) {
        this.toast('未找到该区')
        return
      }

      // 设置筛选状态
      this.isDistrictFiltered = true

      // 设置地图中心和缩放
      if (districtObj.center) {
        this.map.setZoomAndCenter(12, [districtObj.center.lng, districtObj.center.lat])
      }

      // 拉取并渲染该区的信息点
      this.updateShopList()
    },
    async handleSelectCity (item = this.selectedCity) {
      this.searching = false
      // 清除区筛选状态
      this.clearDistrictFilter()
      this.removeMapEventListener()
      let _name = item.value || item.name
      // 有区级，优先定位到区
      this.gdCityList.forEach((city) => {
        let center = null
        if (item.code === city.adcode && !item.districtCode) {
          // 纯市级，无区级
          item.center = city.center
        } else if (item.code === city.adcode && item.districtCode && item.first) {
          // 有区级且第一次进入地图
          const obj = city.districtList.find(v => v.adcode === item.districtCode)
          center = obj.center
        } else if (item.code === city.adcode && item.districtCode && !item.first) {
          // 有区级且非第一次进入地图
          item.center = city.center
        }
        center && (item.center = center)
      })
      if (_name.indexOf('市') !== -1 && this.countyCityList.indexOf(_name) === -1) {
        // 城市信息点列表
        this.setSelectedCity({ ...item })
      }
      if (item.first && item.districtCode) {
        item.value = this.selectedCity.district
        item.code = this.selectedCity.districtCode
        _name = item.value
      }
      // this.map.setCity(item.code)
      if (item.code === '440000') {
        this.selectedDistrict = null
        this.map.setZoomAndCenter(8, item.center)
      } else if (_name.indexOf('市') !== -1 && _name !== '中山市' && _name !== '东莞市' && this.countyCityList.indexOf(_name) === -1) {
        this.selectedDistrict = null
        // // 城市信息点列表
        // this.setSelectedCity(item)
        this.page = 0
        const list = await this.getStoreList({ cityCode: item.code })
        this.shopDataList = list
        this.getDistrictModeCenter = true
        this.map.setZoomAndCenter(10, [item.center.lng, item.center.lat])
      } else if (_name.indexOf('区') !== -1 || _name === '中山市' || _name === '东莞市' || this.countyCityList.indexOf(_name) !== -1 || _name.indexOf('县') !== -1) {
        this.selectedDistrict = item
        this.map.setZoomAndCenter(12, [item.center.lng, item.center.lat])
      }
      this.initMapMarkList(true)
      this.addMapEventListener()
    },
    handleSelectMore () {
      // 若处于区筛选状态 则使用新接口筛选
      this.isDistrictFiltered ? this.updateShopList() : this.getMarkerListByFilterOptionAcytion()
    },
    handleSelectCategory () {
      // 若处于区筛选状态 则使用新接口筛选
      this.isDistrictFiltered ? this.updateShopList() : this.getMarkerListByFilterOptionAcytion()
    },
    handleClickArtifactItem (id) {
      this.focuseMarkerById(id)
    },
    getMarkerListByFilterOptionAcytion () {
      // 先清除数据
      this.clearMapAndmarkIdsData()
      this.initMapMarkList()
    },
    initAmapMarkDom () {
      const dom = Array.from(document.querySelectorAll('.icon-marker'))
      dom.forEach((item) => {
        item.className = 'icon shop-icon-box icon-marker'
        if (item.parentNode.parentNode) {
          item.parentNode.parentNode.style.zIndex = 100
        }
      })
    },
    async getActivityInfo () {
      this.showLoading()
      let detailRes = null
      if (this.storeActivityInfo) {
        detailRes = this.storeActivityInfo
      } else {
        detailRes = await getActivityInfo({
          params: {
            id: this.activityId
          }
        })
      }
      if (detailRes) {
        this.activityInfo = detailRes
        this.initFilterData()
        this.hideLoading()
        await this.initAllShareInfo()
        setDocuemntTtitle(this.activityInfo.name)
      } else {
        this.toast('活动信息获取失败')
        this.hideLoading()
        this.$router.replace('/nothingnessActivity')
      }
    },
    initFilterData () {
      this.selectBarSetting = this.activityInfo.mapStyle.fnModule || {}
    },
    async initAllShareInfo () {
      this.setShareInfo({
        title: this.activityInfo.share.shareTitle,
        desc: this.activityInfo.share.shareDesc,
        link: window.location.href,
        imgUrl: this.activityInfo.share.shareIcon
      })
      try {
        await this.initNfPluseShare()
      } catch (e) {
        window.console.log(e)
      }
      try {
        await initShare({
          shareTitle: this.activityInfo.share.shareTitle,
          shareUrl: window.location.href,
          shareIcon: this.activityInfo.share.shareIcon,
          shareDesc: this.activityInfo.share.shareDesc
        })
      } catch (e) {
        window.console.log(e)
      }
    },
    clearNowSelectedInfo () {
      this.nowSelectedInfo = null
      this.nowSelectedMarkerDom && (this.nowSelectedMarkerDom.parentNode.parentNode.style.zIndex = 100)
      this.nowSelectedMarkerDom && (this.nowSelectedMarkerDom.className = 'icon shop-icon-box icon-marker')
    },
    // 通过条件获取信息点数据
    async getStoreListAndRenderMarkerByOptions (params) {
      this.shopDataList = await this.getStoreList(params)
      this.UpdateAllMapMarker()
    },
    async getAllStoreListByCityId (cityCode = this.selectedCity.code, pageInfo = {}) {
      pageInfo.page && (this.page = pageInfo.page)
      const cacheList = this.cityMapStoreList[cityCode]
      if (cacheList && this.page > cacheList.length - 1) {
        // 翻页完毕 没有数据了
        return this.shopDataList
      }
      let cache = cacheList?.[this.page]
      // 当页数据已缓存 则无需请求
      if (!cache) {
        this.loading = true
        const res = await getShopList({
          cityCode,
          activityId: this.activityId,
          pageNum: this.page,
          pageSize: this.pageSize
        })
        this.loading = false
        if (!res) {
          this.toast('没有更多数据')
          return []
        }
        if (res.code && res.code !== 200) {
          this.toast('网络异常，' + res.msg)
          return []
        }
        const totalPages = res.totalPages
        cache = this.getSortList(res.content)
        if (!this.cityMapStoreList[cityCode]) {
          this.cityMapStoreList[cityCode] = new Array(totalPages).fill(0)
        }
        this.cityMapStoreList[cityCode][this.page] = cache
      }
      if (this.page > 0) {
        return this.getHistoryPageData(this.cityMapStoreList[cityCode])
      }
      return cache
    },
    getHistoryPageData (list) {
      const m = list.slice()
      const historyData = m.splice(0, this.page + 1)
      return historyData.reduce((l, c) => l.concat(c), [])
    },
    async updateStoreList (myParams = {}, pageInfo = {}) {
      const districtCode = this.selectedDistrict?.code || ''
      if (districtCode) return
      const res = await this.getStoreList(myParams, pageInfo)
      this.shopDataList = res
    },
    async getStoreList (myParams = {}, pageInfo = {}) {
      const districtCode = this.selectedDistrict?.code || ''
      if (!this.searching && !districtCode) {
        // 城市信息点 数量多 分页查询
        return this.getAllStoreListByCityId(undefined, pageInfo)
      }
      // 区域信息点请求，数据列表较少，一次性请求
      // const cache = this.districtMapStoreList[districtCode]
      // if (cache) {
      //   return cache
      // }
      // 当用户进入B城市，再通过定位或者挪动地图回到A，校正citycode
      const cityCode = this.districtInfoList.find(i => i.code === districtCode)?.cityCode
      if (cityCode && this.selectedCity.code !== cityCode) {
        const city = this.cityInfoList.find(c => c.code === cityCode)
        console.log('校正citycode', city)
        this.setSelectedCity(city)
      }
      const _params = {
        pageInfo: {
          page: this.page,
          pageSize: 1000,
          ...pageInfo
        },
        params: {
          categoryIds: this.selectCategorieUid.concat(this.moreOptionsId),
          cityCode: this.selectedCity?.code !== '440000' ? this.selectedCity?.code : '',
          activityId: this.activityId,
          coordinates: this.coordinates,
          location: this.userPosition,
          distance: this.distance,
          routeId: this.currentRouteId,
          districtCode,
          ...myParams
        }
      }
      console.error(this.selectedCity)
      this.loading = true
      let res = await getShopInfo(_params)
      this.loading = false
      if (!res) {
        this.toast('没有更多数据')
        return []
      }
      if (res.code && res.code !== 200) {
        this.toast('网络异常，' + res.msg)
        return []
      }
      res = this.getSortList(res.content)
      // this.districtMapStoreList[this.selectedDistrict?.code] = res
      return res
    },
    getSortList (list) {
      return list
        .map((item) => {
          item.distance = getDistance(
            { lng: this.userPosition.longitude, lat: this.userPosition.latitude },
            { lng: item.address.point.x, lat: item.address.point.y }
          )
          return item
        })
        .sort((prev, next) => prev.distance - next.distance)
    },
    UpdateAllMapMarker (currentMode) {
      this.markerList = this.markerList.concat(this.addMapMarker(this.shopDataList, currentMode))
    },
    addMapMarker (storeList = [], currentMode) {
      if (this.map.getZoom() <= 11 && currentMode) return
      currentMode !== this.markerMode && this.clearMapAndmarkIdsData()
      this.circlrMarkerList.length && this.clearAllCircleMarker()
      let overLappingList = []
      const markerList = storeList
        .filter((item) => {
          if (this.markerIdList.includes(item.id)) {
            return false
          } else {
            this.markerIdList.push(item.id)
            return true
          }
        })
        .filter((item) => {
          if (!overLappingList.includes(item.id) && item.hasAdjacentPoint === true) {
            overLappingList = overLappingList.concat(item.adjacentPointStoreIds || [])
          }
          // console.log('overLappingList: ', overLappingList)
          if (overLappingList.includes(item.id) && item.hasAdjacentPoint === true) {
            return false
          } else {
            return true
          }
        })
        .map((item) => {
          const adjacentStr = item.hasAdjacentPoint ? `(重叠${item.adjacentPointStoreIds.length + 1}个)` : ''
          const content = `<div data-id="${item.id}" data-hasAdjacent="${adjacentStr !== ''}" class="icon shop-icon-box icon-marker">
                        <img class="icon-item default-icon" src="${this.matchCategoryImg(item)}" alt="" />
                        <p class="icon-item shop-name">${
                          item.name
                        }<br/><span style="text-align: center; display: inherit; opacity: 0.5;">${adjacentStr}</span></p>
                      </div>`
          return new window.AMap.Marker({
            position: [item.address.point.x, item.address.point.y],
            content,
            anchor: 'top-center',
            extData: {
              id: item.id
            }
          })
        })
      this.map.add(markerList)
      return markerList
    },
    addCircleMarker (dataList = [], currentMode) {
      if (this.map.getZoom() > 11 || this.map.getZoom() < 6) return
      currentMode !== this.markerMode && this.clearMapAndmarkIdsData()
      this.markerList.length && this.clearAllMarker()
      const circlrMarkerList = dataList
        .filter((item) => {
          if (this.circlrMarkerIdsList.includes(item.code)) {
            return false
          } else {
            this.circlrMarkerIdsList.push(item.code)
            return true
          }
        })
        .map((item) => {
          if (!item.center) {
            return {}
          }
          const content = `<div data-id="${item.code}" class="city-marker">
                        <p class="city-marker-item city-marker-name">${item.name}</p>
                        <p class="city-marker-item city-marker-count">${item.count}</p>
                      </div>`
          const marker = new window.AMap.Marker({
            position: [item.center.lng, item.center.lat],
            content,
            anchor: 'center',
            extData: {
              id: item.id
            }
          })
          marker.on('click', this.handleClickCity.bind(this, item))
          return marker
        })
      this.map.add(circlrMarkerList)
      return circlrMarkerList
    },
    // 添加一个市、区气泡被点击的中间函数塞入埋点处理
    handleClickCity (item) {
      if (this.markerMode === 'cityMode') { // 市气泡
        buryingPoint({ action: 12, sourceTag: 2, activityId: this.activityId, optionName: item.name, itemType: 2 })
      } else if (this.markerMode === 'districtMode') { // 区气泡
        buryingPoint({ action: 13, sourceTag: 2, activityId: this.activityId, optionName: item.name, itemType: 2 })
      }
      this.handleSelectCity(item)
    },
    clearMapAndmarkIdsData () {
      this.map.clearMap()
      this.circlrMarkerIdsList = []
      this.markerIdList = []
    },
    clearAllCircleMarker () {
      this.map.clearMap(this.circlrMarkerList)
      this.circlrMarkerList = []
      this.circlrMarkerIdsList = []
    },
    clearAllMarker () {
      this.map.clearMap(this.markerList)
      this.markerList = []
      this.markerIdList = []
    },
    handelShopListIconClick () {
      buryingPoint({ action: 14, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      this.isShowInfoList = !this.isShowInfoList
      this.clearNowSelectedInfo()
    },
    // 清除区筛选状态
    clearDistrictFilter () {
      this.isDistrictFiltered = false
      this.districtSelectParams = {}
      this.$refs.selectBarRef?.resetDistrictStation()
    },
    initAMap (finishCallBack = () => {}) {
      window.map = this.map = new window.AMap.Map('map-container', {
        zoom: this.zoom,
        center: [this.defaultPosition.longitude, this.defaultPosition.latitude],
        animateEnable: true,
        dragEnable: true,
        zoomEnable: true,
        keyboardEnable: true,
        scrollWheel: true,
        // 不配置mapStyle默认为显示地铁
        mapStyle: this.fnModule?.regionalSubway?.checkSubway ? undefined : 'amap://styles/macaron'
      })
      this.addMapEventListener()
      this.map.plugin('AMap.Geolocation', () => {
        this.showLoading()
        const geolocation = new window.AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: false // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        this.map.addControl(geolocation)
        geolocation.getCurrentPosition()
        window.AMap.event.addListener(geolocation, 'complete', this.onComplete) // 返回定位信息
        window.AMap.event.addListener(geolocation, 'error', this.onError) // 返回定位出错信息
        finishCallBack()
      })
      this.map.plugin('AMap.DistrictSearch', () => {
        var districtSearch = new window.AMap.DistrictSearch({
          level: 'province',
          subdistrict: 2
        })
        districtSearch.search('广东省', (status, result) => {
          console.log('广东省', result)
          this.gdCityList = result.districtList[0].districtList
        })
      })
    },
    moveMapend: throttle(function () {
      console.log('moveMapend', this.map.getZoom())
      // 如果处于区筛选状态，不重新请求数据
      if (this.isDistrictFiltered) {
        return
      }
      this.initMapMarkList()
    }, 500),
    mapZoomend: throttle(function () {
      console.log('mapZoomend', this.map.getZoom())
      // 如果处于区筛选状态，且缩放比例未达到市级别，不重新请求数据
      if (this.isDistrictFiltered && this.map.getZoom() >= 11) {
        return
      }
      this.clearDistrictFilter()
      this.initMapMarkList()
    }, 500),
    // 当zoom小于6的时候，不做任何处理；小于12的时候，则显示一个城市的总数；大于12时候，则显示详细信息点点位
    // cityMode, districtMode, noneMode, detailMode
    initMapMarkList (firstEnter = false) {
      setTimeout(() => {
        this.zoom = this.map.getZoom()
        if (this.zoom <= 4) {
          this.handleZeroStoreMode()
        } else if (this.zoom <= 9) {
          this.handleTotalByCityModel()
        } else if (this.zoom <= 11) {
          this.handleTotalByDistrictMode()
        } else {
          this.handleStoreDetailModel(firstEnter)
        }
      }, 600)
    },
    async handleZeroStoreMode () {
      console.log('handleZeroStoreMode')
      this.toast('请放大地图查看')
      this.map.clearMap()
      this.markerMode = 'noneMode'
    },
    async handleTotalByCityModel () {
      const res = await summarize({
        activityId: this.activityId,
        type: 'CITY',
        categoryIds: this.selectCategorieUid.concat(this.moreOptionsId),
        routeId: this.currentRouteId
      })
      if (!res?.length) return
      const cityInfoList = res.map((item) => {
        this.gdCityList.forEach((city) => {
          if (item.code === city.adcode) {
            item.center = city.center
          }
        })
        return item
      })
      this.cityInfoList = cityInfoList
      this.circlrMarkerList = this.circlrMarkerList.concat(this.addCircleMarker(cityInfoList, 'cityMode'))
      this.markerMode = 'cityMode'
    },
    handleTotalByDistrictMode () {
      this.map.getCity(async (info) => {
        const currentCityInfo = this.gdCityList.filter((item) => item.name === info.city)[0]
        const adCode = currentCityInfo?.adcode
        if (!adCode) return
        const res = await summarize({
          activityId: this.activityId,
          type: 'DISTRICT',
          adCode,
          categoryIds: this.selectCategorieUid.concat(this.moreOptionsId),
          routeId: this.currentRouteId
        })
        if (!res?.length) return
        const districtInfoList = res.map((item) => {
          currentCityInfo.districtList.forEach((city) => {
            if (item.code === city.adcode) {
              item.center = city.center
            }
          })
          item.cityCode = currentCityInfo.adcode
          return item
        })
        this.districtInfoList = districtInfoList
        this.circlrMarkerList = this.circlrMarkerList.concat(this.addCircleMarker(districtInfoList, 'districtMode'))
        if (this.markerMode !== 'districtMode' && districtInfoList.length && this.getDistrictModeCenter) {
          const bound = this.map.getBounds()
          const isInViewArray = districtInfoList.filter((p) => isInView({ x: p.center.lat, y: p.center.lng }, { ne: bound.northeast, sw: bound.southwest }))
          isInViewArray.length === 0 && this.map.setZoomAndCenter(10, [districtInfoList[0].center.lng, districtInfoList[0].center.lat])
          this.getDistrictModeCenter = false
        }
        this.markerMode = 'districtMode'
      })
    },
    async handleStoreDetailModel (firstEnter) {
      const bound = this.map.getBounds()
      const center = bound.getCenter()
      this.coordinates = { latitude: center.lat, longitude: center.lng }
      this.distance = getDistance(bound.northeast, bound.southwest)
      this.page = 0
      this.shopDataList = await this.getStoreList()
      const isInViewArray = this.shopDataList.filter((p) => isInView(p.address.point, { ne: bound.northeast, sw: bound.southwest }))
      // const cluster = this.meanShift.cluster(this.shopDataList.map(i => [i.address.point.x, i.address.point.y]))
      console.warn('isInViewArray', isInViewArray)
      if (firstEnter && isInViewArray.length === 0 && this.shopDataList?.length > 0) {
        const { x, y } = this.shopDataList[0].address.point
        this.map.setZoomAndCenter(15, [x, y])
      }
      this.UpdateAllMapMarker('detailMode')
      this.markerMode = 'detailMode'
    },
    async onComplete (obj) {
      console.log('获取用户信息成功：', obj)
      this.userPosition = {
        latitude: obj.position.lat,
        longitude: obj.position.lng,
        valid: true
      }
      this.addUserPoint(obj.position.lng, obj.position.lat)
      this.hideLoading()
      this.firstEnterMap()
    },
    async onError () {
      console.log('获取用户信息失败：')
      this.toast('用户定位失败，使用默认位置')
      this.userPosition = Object.assign({}, this.defaultPosition)
      this.addUserPoint(this.defaultPosition.longitude, this.defaultPosition.latitude)
      this.hideLoading()
      this.firstEnterMap()
    },
    addUserPoint (longitude, latitude) {
      const userPoint = new window.AMap.Marker({
        position: new window.AMap.LngLat(longitude, latitude),
        title: '用户位置'
      })
      this.map.add(userPoint)
    }
  }
}
</script>

<style lang="scss">
.icon-content {
  position: fixed;
  width: 1.06rem;
  top: 5.5rem;
  right: 0.2rem;
  z-index: 90;

  > div {
    margin-bottom: 0.1rem;
  }
}

.icon-marker {
  width: 3rem !important;
  /**解决ios部分低版本手机无法点击到元素 */
  cursor: pointer;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.map-home {
  .back {
    display: none;
    width: 0.95rem;
    height: 0.66rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0 0.38rem 0.38rem 0;
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 9999;
    transform: translate(0, -50%);
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    line-height: 0.66rem;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0;
  }
  .icon-item {
    transition: all 0.3s;
  }

  .city-marker {
    width: 1.0rem;
    height: 1.0rem;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    background-image: linear-gradient(180deg, #ff6019 0%, #dc0808 100%);
    box-shadow: 0 0 10px 0 rgba(99, 0, 0, 0.4);
    text-align: center;
    border-radius: 50%;
    font-size: 0.26rem;
    color: #ffffff;
    letter-spacing: 0;
    .city-marker-item {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .shop-icon-box {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    transform: translateY(-0.65rem);

    .default-icon {
      display: block;
      height: 0.65rem;
      // margin-bottom: 0.1rem;
    }

    .shop-name {
      max-width: 3rem;
      height: auto;
      line-height: 0.4rem;
      padding: 0.1rem 0.2rem;
      background: #ffffff;
      box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
      border-radius: 0.25rem;
      font-size: 0.26rem;
      color: #333333;
    }
  }

  .shop-icon-box-active {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    transform: translateY(-1.2rem);

    .default-icon {
      display: block;
      height: 1.2rem;
      // margin-bottom: 0.1rem;
    }

    .shop-name {
      max-width: 3rem;
      height: auto;
      line-height: 0.4rem;
      padding: 0.1rem 0.2rem;
      background: rgba(0, 0, 0, 0.8);
      box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.2);
      border-radius: 0.25rem;
      font-size: 0.26rem;
      color: #ffffff;
    }
  }

  .map-fake-container {
    .merchant-entry {
      display: none;
      position: fixed;
      font-size: 0;
      top: 1.9rem;
      right: 0;
      width: 1.4rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 998;
    }
    .banner {
      width: 7.5rem;
      height: 2rem;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    #map-container {
      width: 7.5rem;
      height: 100vh;
    }
  }
}
</style>
